import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from 'axios';
import { getDjangoEndpoint } from "src/utils/apiEndpoints";

export interface iLoginState {
  username: string;
  password: string;
  isLoading: boolean;
  message: string;
  response: {
    message: string;
    previous_last_login_at: string;
    last_login_at: string;
    is_first_login: boolean;
  };
}

const initialState: iLoginState = {
  username: "",
  password: "",
  isLoading: false,
  message: "",
  response: {
    message : "",
    previous_last_login_at : "",
    last_login_at : "",
    is_first_login : false
  },
};

//Login API Post 
export const postLoginAPI = createAsyncThunk(
  "GET_LOGIN",
  async (
    loginCheck: { username: string; password: string , remember:boolean},
    { rejectWithValue }
  ) => {
    try {

      const djangoEndpoint = getDjangoEndpoint();
      const pathParam = '/auth/signin/'
        
      const response = await axios.post(
        `${djangoEndpoint}${pathParam}`, 
        {
          username: loginCheck.username,
          password: loginCheck.password,
          remember : loginCheck.remember
          

        },
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      console.error('로그인 API 호출 에러:', error);
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// LoginSlice
export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postLoginAPI.pending, (state) => {
        state.isLoading = true;
        state.message = "";
      })
      .addCase(postLoginAPI.fulfilled, (state, action) => {
        state.isLoading = false;
        state.message = action.payload.message || "Login successful";
        state.response = action.payload;
      })
      .addCase(postLoginAPI.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload as string || "Login failed";
        state.username = "";
      });
  },
});

export default loginSlice.reducer;